import { createContext, ReactNode, useState } from "react";

/**
 * Legacy multi-tenant context kept for API compatibility.
 * Jain eLibrary admin is single-tenant: no URL prefix, no X-Tenant-Id.
 */
interface TenantContextType {
  tenantId: string | null;
  isAtRoot: boolean;
  setTenantId: (id: string) => void;
  clearTenantId: () => void;
}

const TenantContext = createContext<TenantContextType | undefined>(undefined);

interface TenantProviderProps {
  children: ReactNode;
}

export const TenantProvider: React.FC<TenantProviderProps> = ({ children }) => {
  const [state, setState] = useState({
    tenantId: "single" as string | null,
    isAtRoot: true,
  });

  const setTenantIdHandler = (id: string) => {
    setState(s => ({ ...s, tenantId: id }));
  };

  const clearTenantId = () => {
    setState(s => ({ ...s, tenantId: "single" }));
  };

  return (
    <TenantContext.Provider
      value={{
        tenantId: state.tenantId,
        isAtRoot: state.isAtRoot,
        setTenantId: setTenantIdHandler,
        clearTenantId,
      }}
    >
      {children}
    </TenantContext.Provider>
  );
};

export { TenantContext };
